<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <b-row>
          <b-col cols="6">
            <equipe-Select
              ref="filtroEquipe"
              v-model="filtro.equipe"
              :multiple="true"
              @input="alterBotaoCobrar"
            />
          </b-col>
          <b-col cols="6">
            <empresa-multiselect
              ref="filtroEmpresa"
              v-model="filtro.empresas"
              :filtro-adicional="filtroEmpresasEquipe"
              @input="alterBotaoCobrar"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <responsavel-select
              ref="filtroResponsavel"
              v-model="filtro.responsaveis"
              :multiple="true"
              :label="'Usuário responsável'"
              @input="alterBotaoCobrar"
            />
          </b-col>
          <b-col cols="3">
            <departamento-select
              ref="filtroDepartamento"
              v-model="filtro.departamentos"
              :multiple="true"
              @input="alterBotaoCobrar"
            />
          </b-col>
          <b-col cols="3">
            <documento-select
              v-model="filtro.documentos"
              :multiple="true"
              @input="alterBotaoCobrar"
            />
          </b-col>
        </b-row>
        <b-row align-v="start">
          <b-col cols="3">
            <status-select
              v-model="filtro.status"
              :multiple="true"
              :itens-status="itensStatus"
              @input="alterBotaoCobrar"
            />
          </b-col>
          <b-col
            cols="3"
            class="mr-30"
          >
            <div class="w-100">
              <legend class="col-form-label pt-0">
                Competência
              </legend>
              <de-para-competencia
                ref="filtroDeParaCompetencia"
                v-model="filtro.competencia"
                @input="alterBotaoCobrar"
              />
            </div>
          </b-col>
          <b-col
            cols="3"
            class="mr-auto"
          >
            <div class="w-100">
              <legend class="col-form-label pt-0">
                Data de cobrança
              </legend>
              <de-para
                v-model="filtro.cobranca"
                @input="alterBotaoCobrar"
              />
            </div>
          </b-col>
          <b-col
            cols="3"
            style="text-align: end;"
          >
            <legend class="col-form-label pt-0">
              &nbsp;
            </legend>
            <div style="padding-top:6.218px">
              <div
                style="display: inline-block;"
                tabindex="0"
                class="linha-vertical"
              >
                <b-dropdown
                  text="Ações"
                  variant="primary"
                  size="sm"
                  class="mr-50"
                >
                  <b-dropdown-item-btn @click.prevent.stop="cobrancaManual()">
                    <font-awesome-icon
                      class="mr-50"
                      :icon="faPlay"
                      style="color:var(--primary);"
                    />Cobrança manual de documentos
                  </b-dropdown-item-btn>
                  <b-dropdown-item-btn
                    v-b-tooltip.top.html="toolTipDispensa"
                    :disabled="!dispensaDocumentoPendentes"
                    @click.prevent.stop="abrirModalDispensa()"
                  >
                    <font-awesome-icon
                      class="mr-50"
                      :icon="faCheck"
                      style="color:var(--primary);"
                    />Dispensar entrega de documentos
                  </b-dropdown-item-btn>
                  <b-dropdown-item-btn @click.prevent.stop="baixaEmLote()">
                    <font-awesome-icon
                      class="mr-50"
                      :icon="faDownload"
                      style="color:var(--primary);"
                    />Download de documentos em lote
                  </b-dropdown-item-btn>
                  <b-dropdown-item-btn @click.prevent.stop="homologarEmLote()">
                    <font-awesome-icon
                      class="mr-50"
                      :icon="faCheckDouble"
                      style="color:var(--primary);"
                    />Homologar documentos em lote
                  </b-dropdown-item-btn>
                  <b-dropdown-item-btn
                    v-b-tooltip.top.html="tootlTipEnvio"
                    :disabled="!envioDocumentoPendentes"
                    @click.prevent.stop="enviarDocumentos()"
                  >
                    <font-awesome-icon
                      class="mr-50"
                      :icon="faForward"
                      style="color:var(--primary);"
                    />Recobrar documentos pendentes
                  </b-dropdown-item-btn>
                </b-dropdown>
              </div>
              <div style="display: contents;">
                <b-btn
                  variant="none"
                  class="btn-primary btn-sm mr-50 ml-50"
                  @click.prevent.stop="limpar()"
                >Limpar</b-btn>
                <b-btn
                  variant="none"
                  class="btn-primary btn-sm mr-50"
                  @click="aplicar()"
                >Aplicar</b-btn>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr
      class="mx-0 mt-0 my-2"
      style="border-top: 1px solid #a3a4a66b !important;"
    >
    <b-row>
      <b-col cols="12">
        <vue-good-table
          ref="documentos"
          class="relatorio"
          :columns="colunas"
          :rows="documentos"
          :row-style-class="linhaStyleClassFn"
          :pagination-options="{
            enabled: true,
            perPage: 10
          }"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span
              v-if="props.column.field === 'status'"
              v-b-tooltip
              :title="getStatusHint(props.row.status)"
            >
              <font-awesome-icon
                :class="{'text-pendente': props.row.status === 'pendente',
                         'text-success': props.row.status === 'homologado',
                         'text-danger': props.row.status === 'recusado',
                         'text-blue': props.row.status === 'aguardandohomologacao',
                         'text-dispensado': props.row.status === 'dispensado'}"
                :icon="getIconeStatus(props.row.status)"
                style="font-size:1.3rem !important;width:22px"
              />
            </span>
            <span v-else-if="props.column.field === 'nomeEmpresa'">
              <div class="tag-cadastro-federal">
                <span style="margin-right: 0.2rem;">
                  {{ props.row.cadastroFederal }}
                </span>
                <span style="margin-right: 0.2rem;">
                  {{ props.row.matrizFilial }}
                </span>
                <span v-if="props.row.equipe">
                  {{ props.row.equipe }}
                </span>
              </div>
              {{ props.row.nomeEmpresa }}
            </span>
            <span v-else-if="props.column.field === 'complemento'">
              <tag-visualizacao
                v-for="(com, $index) in props.row.complemento"
                :key="$index"
                :value="com"
              />
            </span>
            <span
              v-else-if="props.column.field === 'homologacao'"
              class="homologacao-coluna"
            >
              <b-select
                v-if="props.row.status == 'aguardandohomologacao' && props.row.responsavel"
                v-model="homoSelecionada[props.row.id]"
                :disabled="!props.row.usuarioLogadoPertecente"
                size="sm"
                :options="['Homologar', 'Recusar']"
                @change="alterarStatus(props.row, $event)"
              />
              <b-select
                v-else-if="props.row.status === 'homologado' && props.row.responsavel"
                v-model="props.row.tipoHomologado"
                :disabled="!props.row.usuarioLogadoPertecente"
                size="sm"
                :options="[{text: 'Homologado', value: 'Homologar', disabled: true}, { text: 'Recusar', value: 'Recusar' }]"
                @change="alterarStatus(props.row, $event)"
              />
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </span>
            <span v-else-if="props.column.field === 'acoes'">
              <div class="d-inline-flex">
                <b-btn
                  variant="none"
                  class="mr-50 btn-actions"
                  :disabled="props.row.naoSeAplica || !props.row.publicado"
                  @click="abrirArquivo(props.row)"
                >
                  <font-awesome-icon
                    :icon="faExternalLinkAlt"
                    :class="props.row.publicado ? 'text-success' : 'text-primary'"
                    style="font-size:1.3rem !important;width:22px"
                  />
                </b-btn>
                <b-btn
                  v-if="props.row.naoSeAplica"
                  variant="none"
                  class="btn-actions mr-50"
                  @click="abrirJustificativa(props.row)"
                >
                  <font-awesome-icon
                    :icon="faWindowClose"
                    class="text-primary"
                    style="font-size:1.3rem !important;width:22px"
                  />
                </b-btn>
                <b-btn
                  variant="none"
                  class="btn-actions"
                  @click="abrirHistorico(props.row)"
                >
                  <font-awesome-icon
                    :icon="faHistory"
                    class="text-primary"
                    style="font-size:1.3rem !important;width:22px"
                  />
                </b-btn>
              </div>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
          <!-- no records -->
          <div slot="emptystate">
            <p style="text-align:center; margin:0">
              Nenhum documento encontrado.
            </p>
          </div>
          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Total de {{ props.total }} itens </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="10"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </b-col>
    </b-row>
    <a
      id="download"
      download
      href=""
      hidden
    />
    <justificativa-modal
      v-if="mostrarJustificativa"
      @cancelar="cancelarJustificativa()"
      @hidden="alterarStatus(docSelecionado, 'Recusado', $event)"
    />
    <historico-modal
      v-if="mostrarHistorico"
      :documento-id="docSelecionado.id"
      @hidden="fecharHistorico()"
    />
    <nao-se-aplica-modal
      v-if="mostrarNaoSeAplicaJust"
      :apenas-visualizacao="true"
      :value="naoSeAplicaJust"
      @cancelar="mostrarNaoSeAplicaJust = false"
    />
    <visualizar-arquivo
      v-if="mostarArquivo && arquivo.url"
      :url="arquivo.url"
      :observacao="arquivo.observacao"
      @hidden="fecharArquivo()"
    />

    <justificativa-dispensa
      v-if="mostrarDispensaJust"
      @cancelar="cancelarJustificativa()"
      @aplicar="aplicarDispensa($event)"
    />

    <!--Tela de progresso-->
    <loading
      :is-loading="isLoading"
      :cancelar-upload="cancelarUpload"
      :show-message="mensagemInterna"
      :subtitulo="subMensagemInterna"
    />

    <!--Lista de empresas notificadas manualmente -->
    <b-modal
      ref="empresasDocumento"
      :title="aplicarEnvio ? `Empresas ${manual ? 'cobradas' : 'notificadas'} manualmente` : homologado ? 'Empresas com documentos homologados em lote' :'Empresas com dispensa de entrega de documentos'"
      title-class="font-weight: bold;"
      hide-footer
    >
      <template #default>
        <div
          v-for="(empresa, index) in empresasEnviadas"
          :key="index"
        >
          <b-row>
            <b-col cols="12">
              <span>{{ empresa.nomeEmpresa }} - {{ empresa.inscricao }}</span>
              <strong><br>Departamentos:</strong>
              <div
                v-for="(departamento, departamentoIndex) in empresa.departamentos"
                :key="departamentoIndex"
              >
                <span>{{ departamento }}</span>
              </div>
            </b-col>
          </b-row>
          <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
        </div>
      </template>
    </b-modal>
  </b-card>
</template>

<style lang="scss">
.linha-nao-se-aplica {
  background-color: #f3f2f7;
}

.homologacao-coluna {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.btn-actions {
  padding: 0 !important;
}

.relatorio {
  table.vgt-table {
    font-size: 1.03rem !important;
  }
}

.column-icon {
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  margin-right: 0.5rem;
}

.linha-cancelado {
  background-color: #f3f2f7;
}

.text-dispensado {
  color: #F5B700 !important;
}

.text-pendente {
  color: #FF6B35 !important;
}

@import "@core/scss/vue/libs/vue-good-table.scss";
.th-acao {
  width: 8rem !important;
}
.view {
  .vgt-inner-wrap {
    box-shadow: none !important;
  }
}

.main-menu.menu-dark .navigation > li ul li > a {
  padding: 8px 10px 8px 12px;
}

.icone-acao {
  padding: 0.4rem;
}

.info-close {
  padding: 0 0.62rem 0.2rem 0.62rem !important;
  margin: -0.1rem -0.5rem -0.8rem auto !important;
}

.text-blue {
  color: #549fc7 !important;
}

.tag-cadastro-federal {
  & span {
    font-size: 0.65rem;
    color: var(--primary);
    font-weight: 700;
    background-color: transparent;
    border: 1px solid var(--primary) !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}

.linha-vertical {
  height: 30px;/*Altura da linha*/
  border-right: 1px solid rgb(163 164 166 / 88%);/* Adiciona borda direita na div como ser fosse uma linha.*/
}
</style>

<script>
/* eslint-disable no-underscore-dangle */
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { VueGoodTable } from 'vue-good-table'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHistory, faExternalLinkAlt, faHourglass, faTimesCircle, faCheckCircle, faExclamationCircle, faWindowClose, faBan, faPaperPlane, faPlay, faCheck,
  faCheckDouble, faForward, faDownload,
} from '@fortawesome/free-solid-svg-icons'
import fileUtils from '@core/utils/file-utils'
import api from './shared/services/api'
import { getUserData, isAdmin } from '@/auth/utils'

export default {
  name: 'PortalDocumentoInterno',
  components: {
    VueGoodTable,
    FontAwesomeIcon,
    EmpresaMultiselect: () => import('@/shared/components/empresa-multiselect/EmpresaMultiselect.vue'),
    EquipeSelect: () => import('@/shared/components/equipe-select/EquipeSelect.vue'),
    ResponsavelSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
    DepartamentoSelect: () => import('@/shared/components/departamento-select/DepartamentoSelect.vue'),
    DocumentoSelect: () => import('@/shared/components/documento-select/DocumentoSelect.vue'),
    StatusSelect: () => import('@/shared/components/status-select/StatusSelect.vue'),
    DePara: () => import('@/shared/components/de-para/DePara.vue'),
    DeParaCompetencia: () => import('@/shared/components/de-para-competencia/DeParaCompetencia.vue'),
    JustificativaModal: () => import('./shared/components/justificativa/Justificativa.vue'),
    HistoricoModal: () => import('./shared/components/historico/Historico.vue'),
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
    TagVisualizacao: () => import('@/shared/components/tag-visualizacao/TagVisualizacao.vue'),
    NaoSeAplicaModal: () => import('@/app-modulo/documento/portal-documentos-externo/shared/components/nao-se-aplica/NaoSeAplica.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
    JustificativaDispensa: () => import('./shared/components/justificativa-dispensa/JustificativaDispensa.vue'),
  },
  data() {
    return {
      faHistory,
      faExternalLinkAlt,
      faHourglass,
      faTimesCircle,
      faCheckCircle,
      faExclamationCircle,
      faWindowClose,
      faBan,
      faPaperPlane,
      faPlay,
      faCheck,
      faCheckDouble,
      faForward,
      faDownload,
      colunas: [
        {
          label: 'Status', field: 'status', width: '82px', tdClass: 'text-center',
        },
        { label: 'Empresa', field: 'nomeEmpresa' },
        { label: 'Documento', field: 'documento' },
        { label: 'Complemento', field: 'complemento' },
        {
          label: 'Competência',
          field: 'competencia',
          type: 'date',
          width: '135px',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
          dateOutputFormat: 'MM/yyyy',
        },
        {
          label: 'Cobrança',
          field: 'cobranca',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSS',
          dateOutputFormat: 'dd/MM/yyyy HH:mm',
        },
        {
          label: 'Recebido',
          field: 'recebimento',
        },
        { label: 'Homologação', field: 'homologacao' },
        {
          label: 'Ações', field: 'acoes', width: '80px', tdClass: 'text-right',
        },
      ],
      homologacao: {},
      mostrarJustificativa: false,
      mostrarHistorico: false,
      mostarArquivo: false,
      arquivo: {},
      docSelecionado: null,
      homoSelecionada: {},
      documentos: [],
      filtro: {
        status: null,
        competencia: {},
        cobranca: {},
        responsaveis: [],
      },
      naoSeAplicaJust: '',
      mostrarNaoSeAplicaJust: false,
      mostrarDispensaJust: false,
      itensStatus: [{ tipo: 'aguardandohomologacao', nome: 'Aguardando homologação' },
        { tipo: 'homologado', nome: 'Homologado' },
        { tipo: 'pendente', nome: 'Pendente' },
        { tipo: 'recusado', nome: 'Recusado' },
        { tipo: 'cancelado', nome: 'Cancelado' },
        { tipo: 'dispensado', nome: 'Dispensado' }],
      habilitarEnvio: false,
      habilitarDispensa: false,
      isLoading: false,
      empresasEnviadas: [],
      toolTipDispensa: `<strong>Atenção:</strong> o botão "Dispensar entrega de documentos" validará os filtros incluídos no portal para efetuar a dispensa de entrega dos 
      documentos com status "Pendente" e "Recusado". Importante: sempre que alterar os filtros da tela do portal, utilize de imediato o botão de "Aplicar" para atualizar as 
      informações listadas no portal, caso o filtro não esteja aplicado, o sistema não habilitará a funcionalidade.`,
      tootlTipEnvio: `<strong>Atenção:</strong> O botão "Recobrar documentos pendentes" somente habilitará para utilização quando no filtro de documento estiver sem filtro aplicado e
      no filtro de status estiver sem filtro ou com Pendente.<br> <strong>Importante:</strong> sempre que alterar os filtros da tela do portal, utilize de imediato o
      botão de "Aplicar" para atualizar as informações listadas no portal, caso o filtro não esteja aplicado, o sistema não habilitará o botão de
      "Recobrar documentos pendentes".`,
      dispensaEntrega: false,
      aplicarEnvio: false,
      mensagemInterna: '',
      subMensagemInterna: null,
      cancelado: false,
      controller: null,
      manual: false,
      homologado: false,
    }
  },
  computed: {
    envioDocumentoPendentes: {
      get() {
        return (((this.filtro.status === null || this.filtro.status.length === 0) || (this.filtro.status !== null && this.filtro.status.find(f => f.tipo === 'pendente')))
            && ((this.filtro.documentos === undefined || this.filtro.documentos === null) || this.filtro.documentos.length === 0) && this.habilitarEnvio)
      },
    },
    dispensaDocumentoPendentes: {
      get() {
        return (((this.filtro.status === null || this.filtro.status.length === 0) || (this.filtro.status !== null && this.filtro.status.some(som => som.tipo === 'pendente' || som.tipo === 'recusado')))
          && this.habilitarDispensa && this.dispensaEntrega)
      },
    },
  },
  created() {
    this.getFilterLocalStorage()
    this.dispensaEntrega = getUserData().dispensaEntrega
    if (this.filtro.responsaveis.length === 0) {
      api.getFiltrosIniciais()
        .then(payload => {
          const filtros = payload.data
          this.filtro.responsaveis = filtros.responsaveis
          if (this.$refs.filtroResponsavel) {
            this.$refs.filtroResponsavel.value_ = filtros.responsaveis
          }
          this.aplicar()
        })
        .catch(err => {
          throw err
        })
    } else {
      this.aplicar()
    }
  },
  beforeDestroy() {
    localStorage.removeItem('filtro')
  },
  methods: {
    getIconeStatus(value) {
      if (value === 'aguardandohomologacao') {
        return this.faHourglass
      }

      if (value === 'pendente') {
        return this.faExclamationCircle
      }

      if (value === 'recusado') {
        return this.faTimesCircle
      }

      if (value === 'homologado') {
        return this.faCheckCircle
      }

      if (value === 'cancelado') {
        return this.faBan
      }

      if (value === 'dispensado') {
        return this.faCheckCircle
      }

      return ''
    },
    getStatusHint(value) {
      if (value === 'aguardandohomologacao') {
        return 'Aguardando homologação'
      }

      if (value === 'pendente') {
        return 'Pendente'
      }

      if (value === 'recusado') {
        return 'Recusado'
      }

      if (value === 'homologado') {
        return 'Homologado'
      }

      if (value === 'cancelado') {
        return 'Cancelado'
      }

      if (value === 'dispensado') {
        return 'Dispensado'
      }

      return ''
    },
    linhaStyleClassFn(row) {
      const css = 'clickable'
      if (row.naoSeAplica) { return `linha-nao-se-aplica ${css}` }

      if (row.status === 'cancelado') { return `linha-cancelado ${css}` }
      return css
    },
    aplicar() {
      this.documentos = []
      if (this.validarDatas(this.filtro.competencia.dataInicio, this.filtro.competencia.dataFim)) {
        api.getCobrancas(this.filtro)
          .then(payload => {
            this.documentos = payload.data
            this.habilitarEnvio = true
            this.habilitarDispensa = true
          })
          .catch(err => {
            this.notificarErro('Não foi possível carregar os documentos para conferência.', err)
            throw err
          })
      } else {
        this.$erro('A competência inicial não pode ser maior que competência final.')
      }
    },
    setFilter() {
      const item = JSON.stringify(this.filtro)
      localStorage.setItem('filtro', item)
    },
    getFilterLocalStorage() {
      const filter = localStorage.getItem('filtro')
      if (filter || filter !== null) {
        const newFilter = JSON.parse(filter)
        this.filtro = newFilter
        this.filtro.competencia = newFilter.competencia
        this.$set(this.filtro, 'competencia', newFilter.competencia)
      }
    },
    limpar() {
      this.documentos = []
      this.filtro = {
        empresas: null,
        departamentos: null,
        responsaveis: null,
        documentos: null,
        status: null,
        cobranca: {},
        competencia: {},
        justificativa: '',
      }
      this.habilitarEnvio = false
      this.habilitarDispensa = false
    },
    abrirArquivo(documento) {
      this.docSelecionado = documento
      api.getURLDocumento(documento.id)
        .then(payload => {
          this.arquivo = payload.data
          this.mostarArquivo = true
        })
        .catch(err => {
          this.fecharArquivo()
          this.notificarErro('Não foi abrir a visualização de arquivo.', err)
          throw err
        })
    },
    fecharArquivo() {
      this.mostarArquivo = false
      this.docSelecionado = null
      this.arquivo = {}
    },
    abrirHistorico(documento) {
      this.mostrarHistorico = true
      this.docSelecionado = documento
    },
    fecharHistorico() {
      this.mostrarHistorico = false
      this.docSelecionado = null
    },
    cancelarJustificativa() {
      if (this.docSelecionado) {
        const index = this.documentos.findIndex(d => d.id === this.docSelecionado.id)
        if (index > -1) {
          const documento = this.documentos.find(d => d.id === this.docSelecionado.id)
          if (documento.status === 'homologado') {
            documento.tipoHomologado = 'Homologar'
            this.documentos.splice(index, 1)
            this.documentos.splice(index, 0, documento)
          }
        }
      }
      this.docSelecionado = null
      this.mostrarJustificativa = false
      this.homoSelecionada = {}
      this.mostrarDispensaJust = false
    },
    alterarStatus(documento, $event, justificativa) {
      this.mostrarJustificativa = false
      this.docSelecionado = null

      if ($event === 'Recusar') {
        this.docSelecionado = documento
        this.mostrarJustificativa = true
      } else if ($event === 'Homologar') {
        this.$swal({
          title: 'Deseja homologar este documento?',
          text: 'Ao realizar essa ação você informará aos contatos que o documento está homologado.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.homologar(documento, $event)
          }
          this.homoSelecionada = {}
        })
      } else if ($event === 'Recusado') {
        this.homologar(documento, $event, justificativa)
      }
    },
    homologar(documento, value, justificativa = '') {
      api.homologar(documento.id, value === 'Homologar', justificativa)
        .then(payload => {
          this.$set(documento, 'status', payload.data.status)
          this.$set(documento, 'homologacao', payload.data.homologacao)
          this.$set(documento, 'tipoHomologado', payload.data.status === 'homologado' ? 'Homologar' : null)
          const index = this.documentos.findIndex(d => d.id === documento.id)
          if (index > -1) {
            this.documentos.splice(index, 1)
            this.documentos.splice(index, 0, documento)
          }
          this.cancelarJustificativa()
          this.notificarSucesso(`Documento ${payload.data.status === 'rescudao' ? 'recusado' : 'homologado'}.`)
        })
        .catch(err => {
          this.cancelarJustificativa()
          this.notificarErro('Não foi possível homologar o documento.', err)
          throw err
        })
    },
    enviarDocumentos() {
      this.aplicarEnvio = true
      this.manual = false
      this.homologado = false
      // eslint-disable-next-line global-require
      const axios = require('axios')
      this.$swal({
        text: 'O sistema validará os filtros incluídos no portal para disparar a notificação da cobrança de documentos pendentes. '
        + 'Porém, para fins de segurança do processo, somente será validado as empresas e departamentos que o usuário logado no sistema é responsável. '
        + 'Para usuários administradores será validado somente os filtros incluídos no portal. Deseja continuar?',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCancelButton: true,
        focusConfirm: false,
        icon: 'question',
        type: 'question',
        customClass: {
          confirmButton: 'mr-1 w-25 btn-primary',
          cancelButton: 'w-25 btn-danger',
        },
      })
        .then(result => {
          if (result.value && this.podeRealizarAcao()) {
            this.isLoading = true
            api.enviar(this.filtro, axios.CancelToken)
              .then(payload => {
                this.isLoading = false
                this.empresasEnviadas = payload.data
                this.$refs.empresasDocumento.show()
              })
              .catch(err => {
                if (err.response === undefined) {
                  this.notificarErro('Processo cancelado')
                } else {
                  this.mostrarMensagemAtencao(err.response.data.message)
                }
                this.isLoading = false
              })
          }
        })
    },
    mostrarMensagemAtencao(msg) {
      this.$swal({
        title: 'Processo não realizado!',
        text: msg,
        icon: 'warning',
        type: 'warning',
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      })
    },
    cancelarUpload() {
      this.isLoading = false
      fileUtils.cancelarBaixaEmDocumentos()
      api.cancelarEnvio()
    },

    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    },
    notificarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'SuccessCircleIcon',
          variant: 'success',
        },
      })
    },
    abrirJustificativa(documento) {
      this.naoSeAplicaJust = documento.naoSeAplicaJust
      this.mostrarNaoSeAplicaJust = true
    },
    alterBotaoCobrar() {
      this.setFilter()
      this.habilitarEnvio = false
      this.habilitarDispensa = false
    },
    abrirModalDispensa() {
      this.mostrarDispensaJust = true
    },
    aplicarDispensa(value) {
      this.aplicarEnvio = false
      this.manual = false
      this.homologado = false
      // eslint-disable-next-line global-require
      const axios = require('axios')
      this.mostrarDispensaJust = false
      this.isLoading = true
      this.filtro.justificativa = value.justificativa
      api.dispensarDocumentos(this.filtro, axios.CancelToken)
        .then(payload => {
          this.isLoading = false
          this.empresasEnviadas = payload.data
          this.empresasEnviadas.forEach(each => {
            each.documentosAlterados.forEach(eac => {
              const documento = this.documentos.find(find => find.id === eac)
              if (documento) {
                this.$set(documento, 'status', 'dispensado')
              }
            })
          })
          this.$refs.empresasDocumento.show()
        })
        .catch(err => {
          if (err.response === undefined) {
            this.notificarErro('Processo cancelado')
          } else {
            this.mostrarMensagemAtencao(err.response.data.message)
          }
          this.isLoading = false
        })
    },
    filtroEmpresasEquipe(value) {
      if (this.filtro.equipe && this.filtro.equipe.length > 0) {
        return value.filter(fil => this.filtro.equipe.find(fin => fin.nome === fil.equipe))
      }
      return value
    },
    baixaEmLote() {
      this.cancelado = false
      this.$confirmarHtml('', 'O sistema validará os filtros incluídos em tela para realizar o download em lote. Será gerado um único arquivo zip com todos os documentos separado por empresa. <br><strong>Atenção:</strong> é recomendado que seja utilizado filtros por empresa, status ou departamentos para otimizar a performance do processo.<br><br> Deseja continuar?', 'question', 'danger')
        .then(result => {
          if (result.value) {
            this.mensagemInterna = 'Aguarde, estamos buscando os arquivos da nuvem!'
            this.subMensagemInterna = 'Atenção: é recomendado que seja utilizado filtros por empresa, status ou departamentos para otimizar a performance do processo.'
            // eslint-disable-next-line global-require
            const axios = require('axios')
            this.isLoading = true
            api.baixaEmLote(this.filtro, axios.CancelToken)
              .then(async payload => {
                const dados = payload.data
                const resposta = await fileUtils.makeZip(dados)
                if (resposta.status === 'sucesso') {
                  this.$sucesso(resposta.mensagem)
                } else {
                  this.$erro(resposta.mensagem)
                }
              })
              .catch(err => {
                if (err.response === undefined) {
                  this.$erro('Processo cancelado')
                } else {
                  this.$erro(err.response.data.message || err.message)
                }
                throw err
              })
              .finally(() => {
                this.mensagemInterna = ''
                this.subMensagemInterna = null
                this.isLoading = false
                this.cancelado = false
              })
          }
        })
    },
    cobrancaManual() {
      this.aplicarEnvio = true
      this.manual = true
      this.homologado = false
      this.$confirmarHtml('', 'O sistema validará os filtros incluídos no portal para disparar a cobrança de documentos manual. Porém, para fins de segurança do processo, somente será validado as empresas e departamentos que o usuário logado no sistema é responsável. Para usuários administradores será validado somente os filtros incluídos no portal. Lembrando, que para esse processo somente é validado os filtros por Equipe, Empresa e Departamento.<br><br> Deseja continuar?', 'question', 'danger')
        .then(result => {
          if (result.value && this.podeRealizarAcao()) {
            // eslint-disable-next-line global-require
            const axios = require('axios')
            this.isLoading = true
            api.gerarCobrancaManua(this.filtro, axios.CancelToken)
              .then(payload => {
                this.isLoading = false
                this.empresasEnviadas = payload.data
                this.$refs.empresasDocumento.show()
              })
              .catch(err => {
                if (err.response === undefined) {
                  this.notificarErro('Processo cancelado')
                } else {
                  this.mostrarMensagemAtencao(err.response.data.message)
                }
                this.isLoading = false
              })
          }
        })
    },
    homologarEmLote() {
      this.aplicarEnvio = false
      this.manual = false
      this.homologado = true
      this.$confirmarHtml('', 'O sistema validará os filtros incluídos no portal para homologar os documentos. Porém, para fins de segurança do processo, somente será validado as empresas e departamentos que o usuário logado no sistema é responsável. Para usuários administradores será validado somente os filtros incluídos no portal. Lembrando, que para esse processo somente é validado os documentos com status "Aguardando homologação".<br><br> Deseja continuar?', 'question', 'danger')
        .then(result => {
          if (result.value && this.podeRealizarAcao()) {
            // eslint-disable-next-line global-require
            const axios = require('axios')
            this.isLoading = true
            api.homologarEmLote(this.filtro, axios.CancelToken)
              .then(payload => {
                this.empresasEnviadas = payload.data
                this.empresasEnviadas.forEach(each => {
                  each.documentosAlterados.forEach(eac => {
                    const documento = this.documentos.find(find => find.id === eac)
                    if (documento) {
                      this.$set(documento, 'status', 'homologado')
                      this.$set(documento, 'tipoHomologado', 'Homologar')
                    }
                  })
                })
                this.isLoading = false
                this.$refs.empresasDocumento.show()
              })
              .catch(err => {
                if (err.response === undefined) {
                  this.notificarErro('Processo cancelado')
                } else {
                  this.mostrarMensagemAtencao(err.response.data.message)
                }
                this.isLoading = false
              })
          }
        })
    },
    podeRealizarAcao() {
      if (!isAdmin()) {
        if ((!this.filtro.empresas || this.filtro.empresas.length === 0) && (!this.filtro.departamentos || this.filtro.departamentos.length === 0)) {
          this.mostrarMensagemAtencao('Para executar esse processo é obrigatório informar o filtro por empresa ou departamento. Verifique a informação!')
          return false
        }
        if ((!this.filtro.empresas || this.filtro.empresas.length === 0) && (this.filtro.departamentos && this.filtro.departamentos.length > 1)) {
          this.mostrarMensagemAtencao('Não é permitido executar esse processo simultaneamente para mais de um departamento. Verifique a informação!')
          return false
        }
      }
      return true
    },
    validarDatas(dataInicial, dataFinal) {
      if (dataInicial && dataFinal) {
        const dataInicialObj = new Date(dataInicial)
        const dataFinalObj = new Date(dataFinal)
        if (dataFinalObj >= dataInicialObj) {
          return true
        }
        return false
      }
      return true
    },
  },
}
</script>
